import {BaseEntity, cookies, DefaultEntity, Filter, QueryParams, RestDataSource} from "@intermesh/goui";
import {PortalConfig} from "../../config.js";

export class DataSource<Type extends BaseEntity = DefaultEntity> extends RestDataSource<Type> {
	returnProperties?: string;
	constructor(path:string, returnProperties?: string) {

		super(PortalConfig.APIUrl + path, path, {
			mode: "same-origin",
			headers: {
				"Content-Type": "application/json",
			}
		});
		this.returnProperties = returnProperties
	}

	protected async add(data: Type) {

		this.removeMarkDeleted(data);

		return super.add(data);
	}

	/**
	 * The IFW API uses a markDeleted property to remove items from array properties. We need to
	 * clear those after save.
	 *
	 * @param data
	 * @private
	 */
	private removeMarkDeleted(data:any) {
		for(let p in data) {
			if(data[p] && typeof data[p] == 'object') {
				if(data[p].markDeleted) {
					delete data[p];
				} else {
					this.removeMarkDeleted(data[p])
				}
			}

		}
	}

	protected async request(path: string = "", options: RequestInit = {}, queryParams?: URLSearchParams) {

		(this.baseRequestOptions.headers as Record<string, string>).Authorization = "Token " + cookies.get("accessToken");
		if(this.returnProperties && !queryParams?.has("returnProperties")) {

			if(!queryParams) {
				queryParams = new URLSearchParams();
			}
			queryParams.set('returnProperties',this.returnProperties);
		}
		return super.request(path, options, queryParams);
	}

	protected async createErrorFromResponse(response: Response) {
		const text = await response.text();
		try {

			const data = JSON.parse(text);

			if(data.data && data.data.validationErrors) {
				return {type: "invalidProperties", validationErrors: data.data.validationErrors, data: data};
			} else {
				return {type: "serverFail",  data: data, message: data.errors[0]};
			}
		}	catch(e) {
			//ignore
		}

		return new Error("Request error: " + response.status + " " + response.statusText + "\n\n" + text);
	}

	protected queryParamsToUrlParams(params: QueryParams): URLSearchParams {
		const p = super.queryParamsToUrlParams(params);
		let q:any = [];
		if(params.filter) {
			this.filterToQ(params.filter, q, q, p);
		}
		if(q.length) {
			p.set("q", JSON.stringify(q));
		}

		return p;
	}

	/**
	 * Transforms JMAP filters to the IFW 'q' parameter.
	 *
	 * @param filter
	 * @param q
	 * @param mainQ
	 * @param urlSearchParams
	 * @private
	 */
	private filterToQ(filter:Filter,q:any, mainQ:any, urlSearchParams:URLSearchParams) {
		if(Array.isArray(filter)) {
			filter.forEach((k) => {
				q.push(k);
			});
			return;
		}

		let setFilters = false;
		if(filter.operator) {
			const subQ:any = [];
			filter.conditions!.forEach(f => {
				this.filterToQ(f, subQ, q, urlSearchParams);
			});
			if(subQ.length > 0) {
				q.push(["whereGroup", subQ, "AND"]);
			}
		} else {
			for (const k in filter) {
				// If a filter name ends with Filter, this is most probably a filter class in the API. These are not
				// to be included in the q URLSerchParam, but handled separately!
				if(k.endsWith("Filter") || k.indexOf("FilterFactory") > -1) {
					if(!setFilters) {
						setFilters = true;
						urlSearchParams.set("useFilters", "1");
					}
					urlSearchParams.set(k, filter[k].join(","));
				} else {
					const parts = k.split(".");
					if (parts.length > 1) {
						parts.pop();
						mainQ.push(['joinRelation', parts.join(".")])
					}

					if(k == "searchQuery") {
						urlSearchParams.set("searchQuery", filter[k]);
					} else if(k === "requirePermissionType") {
						mainQ.push([k, filter[k]]);
					} else {
						q.push(['andWhere', {[k]: filter[k]}]);
					}
				}
			}
		}
	}

}
